import Nullstack from 'nullstack';
export default function IconWallOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wall-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-12a2 2 0 0 1 -2 -2v-12c0 -.55 .222 -1.047 .58 -1.409"
  }), "   ", Nullstack.element("path", {
    d: "M4 8h4m4 0h8"
  }), "   ", Nullstack.element("path", {
    d: "M20 12h-4m-4 0h-8"
  }), "   ", Nullstack.element("path", {
    d: "M4 16h12"
  }), "   ", Nullstack.element("path", {
    d: "M9 4v1"
  }), "   ", Nullstack.element("path", {
    d: "M14 8v2"
  }), "   ", Nullstack.element("path", {
    d: "M8 12v4"
  }), "   ", Nullstack.element("path", {
    d: "M11 16v4"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}